import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Collapse, PageHeader, Popconfirm, Space, Pagination } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import CopyWrapper from "../../../components/CopyWrapper";
import ProjectStore, { ProjectInfo } from "../../../stores/Admin/ProjectStore";
import Applications from "./Applications";
import ApplicationAddDialog from "./dialogs/ApplicationAddDialog";
import ApplicationEditDialog from "./dialogs/ApplicationEditDialog";
import ApplicationDescribeDialog from "./dialogs/ApplicationDescribeDialog";
import TagLabel from "./TagLabel";
import ProjectAddDialog from "./dialogs/ProjectAddDialog";
import ProjectEditDialog from "./dialogs/ProjectEditDialog";
import styles from "./index.module.scss";
import AppStore from "../../../stores/User/AppStore";
const { Panel } = Collapse;

const ProjectsPage: React.FC = (props) => {
  const [visibles, setVisibles] = useState<{ [key: string]: any }>({
    projectAdd: false,
    projectEdit: false,
    appEdit: false,
    appDescribe: false,
  });

  const { projects, pagination } = ProjectStore;
  const [appEditId, setAppEditId] = useState<number[]>([]);
  const [appAddProjectId, setAppAddProjectId] = useState<number>();
  const [projectInfo, setProjectInfo] = useState<{
    id: number;
    name: string;
    des?: string;
    sort?: number;
  }>({ id: 0, name: "" });

  const updateVisibles = (key: string, value: any) => {
    visibles[key] = value;
    setVisibles({ ...visibles });
  };

  useEffect(() => {
    ProjectStore.loadProjects();
    return () => {
      ProjectStore.setPagination({ total: 0, pageNum: 1, pageSize: 10 });
    };
  }, []);

  const getProjectHeader = (project: ProjectInfo) => {
    return (
      <div className={styles.project_header}>
        <label>{project.name}</label>

        <span
          className={styles.header_btn}
          onClick={(e) => {
            e.stopPropagation();
            setProjectInfo({
              id: project.id,
              name: project.name,
              des: project.des,
              sort: project.sort,
            });
            updateVisibles("projectEdit", true);
          }}
        >
          <EditOutlined style={{ color: "#1890ff" }} />
        </span>

        <span className={styles.header_btn} onClick={(e) => e.stopPropagation()}>
          <Popconfirm
            title="是否删除该项目"
            okText="确认"
            cancelText="取消"
            onConfirm={() => ProjectStore.removeProject(project.id)}
          >
            <DeleteOutlined style={{ color: "red" }} />
          </Popconfirm>
        </span>
      </div>
    );
  };

  return (
    <div>
      <PageHeader title="我的项目" />

      <div className={styles.content}>
        <div style={{ marginBottom: 16 }}>
          <Button
            shape="round"
            type="primary"
            onClick={() => {
              updateVisibles("projectAdd", true);
              AppStore.getTag();
            }}
          >
            新建项目
          </Button>
        </div>

        <Collapse>
          {projects?.map((project) => (
            <Panel header={getProjectHeader(project)} key={project.id}>
              <div className={styles.project_content}>
                <div className={styles.project_tag}>
                  <TagLabel id={project.id} />
                  {/* <div>
                    <span>行业：123123</span>
                    <span>其他：123123</span>
                  </div>
                  <Button shape="round" type="primary">
                    修改
                  </Button> */}
                </div>

                <p className={styles.public_key_line}>
                  <div className={styles.key_wrapper}>
                    <label>app secret：</label>
                    <span className={styles.key_box}>{project.publicKey}</span>

                    <CopyWrapper selector={`[data-type="${`copy-btn-${project.id}`}"]`}>
                      <Button
                        shape="round"
                        type="primary"
                        data-type={`copy-btn-${project.id}`}
                        data-clipboard-text={project.publicKey}
                      >
                        复制
                      </Button>
                    </CopyWrapper>
                    <Button
                      shape="round"
                      style={{ marginLeft: 10 }}
                      onClick={() => ProjectStore.reloadPublicKey(project.id)}
                    >
                      重置
                    </Button>
                  </div>

                  <Button
                    shape="round"
                    type="primary"
                    onClick={() => {
                      updateVisibles("appAdd", true);
                      setAppAddProjectId(project.id);
                    }}
                  >
                    新建应用
                  </Button>
                </p>

                <Applications
                  projectId={project.id}
                  project={project}
                  onEdit={(appId) => {
                    setAppEditId([project.id, appId]);
                    updateVisibles("appEdit", true);
                  }}
                  onDescribe={(appId) => {
                    setAppEditId([project.id, appId]);
                    updateVisibles("appDescribe", true);
                  }}
                />
              </div>
            </Panel>
          ))}
        </Collapse>
        <Pagination
          total={pagination.total}
          showTotal={(total) => `共有${total}个项目`}
          onChange={(pageNum: number, pageSize: number) => {
            ProjectStore.setPagination({ ...pagination, pageNum, pageSize });
            ProjectStore.loadProjects(pageNum, pageSize);
          }}
          pageSize={pagination.pageSize}
          current={pagination.pageNum}
        />
      </div>

      <ProjectAddDialog visible={visibles.projectAdd} close={() => updateVisibles("projectAdd", false)} />

      <ProjectEditDialog
        visible={visibles.projectEdit}
        close={() => updateVisibles("projectEdit", false)}
        projectInfo={projectInfo}
      />
      <ApplicationEditDialog
        visible={visibles.appEdit}
        close={() => updateVisibles("appEdit", false)}
        projectId={appEditId[0]}
        appId={appEditId[1]}
      />

      <ApplicationAddDialog
        visible={visibles.appAdd}
        close={() => updateVisibles("appAdd", false)}
        projectId={appAddProjectId}
      />
      <ApplicationDescribeDialog
        visible={visibles.appDescribe}
        close={() => updateVisibles("appDescribe", false)}
        projectId={appEditId[0]}
        appId={appEditId[1]}
      />
    </div>
  );
};

export default observer(ProjectsPage);
